import { isPersonalWorkEnabled } from "../../shared/personalWork";
import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function usePersonalWorkEnabled(): boolean | undefined {
  const [tenant] = useQuery(queries.currentTenant());
  return tenant ? isPersonalWorkEnabled(tenant) : undefined;
}
